
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1(121|384|423|689)|7(410|589|905)|258|2881|3341|4419|5093|5922|602|6589|8415)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
